import * as React from "react";
import {
  BrowserRouter as Router, Route,
  Routes
} from "react-router-dom";
import Dashboard from "./Dashboard.tsx";
import Home from "./Home.tsx";
import NavBar from "./NavBar.tsx";

const App: React.FC = () => {


  return (
    <Router>
      <div>
        <NavBar />
        <Routes>
        <Route path="/" element={<Home />} />
          <Route path="/dashboard" element={<Dashboard />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
